module.exports = __webpack_public_path__ + "static/media/linkedin-grey.214b0be6.svg";